import ApiService from './ApiService'

const UnitTypeService = {
    _prepareData(data, rvt) {
        const preparedData = {
            ...data,
        }

        const { buy_back, ...extractedUnitTypeData } = preparedData
        if (buy_back) {
            extractedUnitTypeData.residual_values_table = { ...rvt }
        }

        return extractedUnitTypeData
    },

    async get(type) {
        const { data } = await ApiService.get('unit_type.show', type)
        return data
    },

    async getDefaultRvShare() {
        const { data } = await ApiService.get('unit_type.default_rv_share')
        return data.default_rv_share
    },

    create(data, rvt) {
        return ApiService.post('unit_type.store', this._prepareData(data, rvt))
    },

    update(type, data, rvt) {
        return ApiService.patch('unit_type.update', this._prepareData(data, rvt), type)
    },

    delete(type) {
        return ApiService.delete('unit_type.destroy', type)
    },

    calculateRVT(type) {
        const inputs = {
            value: type.value,
            residual_value_day_1: type.residual_value_day_1,
            residual_value_1_year: type.residual_value_1_year,
            rv_depreciation_period_years: type.rv_depreciation_period_years,
        }
        return ApiService.post('unit_type.get_residual_values_table', inputs, { type: type.id })
    },

    getResidualValue(inputs) {
        const { duration, expected_utilization, unit_type } = inputs
        const requestData = {
            months: duration * 12,
            annual_utilization: expected_utilization,
        }
        return ApiService.post('unit_type.residual_value', requestData, unit_type)
    },
}

export default UnitTypeService
